import React from 'react';

const Hero: React.FC = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToHowItWorks = () => {
    const element = document.getElementById('how-it-works');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="container">
        <h1>Le premier avantage salarié qui récompense l'économie circulaire</h1>
        <p>AskEko est une application en marque blanche qui connecte les salariés aux acteurs de confiance de l'économie circulaire pour réparer, vendre, acheter, donner, prêter et louer.</p>
        <div className="hero-buttons">
          <button className="btn btn-primary" onClick={scrollToContact}>
            Demander une démo
          </button>
          <button className="btn btn-secondary" onClick={scrollToHowItWorks}>
            En savoir plus
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
